import { createSearchParams, matchPath } from "react-router";
import { buildPath } from "./helpers";

export const RegexpPatterns = {
  email:
    /^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))?$/, //NOSONAR
};

//Project Specific

export const DEFAULT_LANGUAGE = "fr";
export const DEFAULT_COUNTRY = "FR";
export const DEFAULT_NETWORK = "ATLFR";
export const SERVER_DATE_FORMAT = "YYYY-MM-DD";
export const SERVER_DATE_TIME_FORMAT = "YYYY-MM-DD[T]HH:mm:ss";
export const DEFAULT_TIME_FORMAT = "HH:mm:ss";

export const REQUIRED_CHAR = "!";

export const STORAGE_KEYS = {
  Language: "LANGUAGE",
  Mode: "MODE",
};

export const APP_URL = {
  Base: buildPath("/", ":network"),
  Login: "login",
  WSOCallback: "wso/callback",
  Template: "template",
  FactoryStructure: "factory-structure",
  CGU: "cgu",
  FAQ: "FAQ",
  Profile: "profile",
  Heating: "chauffage",
  Etude: "etude/:etudeType/:etudeId",
  MyEtudes: "my-etudes",
  Solutions: "solutions",
  SolutionDetails: "solutions/:selectedDetail",
  SolutionDetailAccesories: "solutions/:selectedDetail/accessoires",
  SolutionDetailDocuments: "documents",
};

export type Entities =
  | "product"
  | "step"
  | "workInstruction"
  | "operation"
  | "sequence"
  | "instructionFile"
  | "checklist"
  | "component"
  | "printingFunction"
  | "qualityFile"
  | "controlFile";

export const getDefaultNetwork = () => {
  if (window.location.host.indexOf('.acv.com') !== -1) {
    return "ACVFR";
  } else if (window.location.host.indexOf('.atlantic-pros.fr') !== -1) {
    return "ATLFR";
  }

  return DEFAULT_NETWORK;
}

export const getNetworkFromUrl = (networkCode: string) => {
  let _network = getDefaultNetwork();
  switch (networkCode) {
    case "ATLFR":
      _network = "ATLFR";
      break;
    case "ACVFR":
      _network = "ACVFR";
      break;
    case "YGNBE":
      _network = "YGNBE";
      break;
    case "YGNIT":
      _network = "YGNIT";
      break;
    case "ACVES":
      _network = "ACVES";
      break;
    case "ACVUK":
      _network = "ACVUK";
      break;
    case "HAMUK":
      _network = "HAMUK";
      break;
    case "ACVGABe":
      _network = "ACVGABe";
      break;
    case "IDEAL":
      _network = "IDEAL";
      break;
    case "ACVPL":
      _network = "ACVPL";
      break;
    case "ACVDE":
      _network = "ACVDE";
      break;
    case "ACVCZ":
      _network = "ACVCZ";
      break;
    case "ACVIT":
      _network = "ACVIT";
      break;
    case "ATLPOL":
      _network = "ATLPOL";
      break;
  }

  return _network;
}

export const getAppUrl = (
  url: string,
  options?: {
    searchParams?: Record<string, string>;
    network?: string;
  }
) => {
  // if (url === undefined) {
  //   const match = matchPath(
  //     { path: APP_URL.Base, end: false },
  //     window.location.pathname
  //   );
  //   const path = window.location.pathname.replace(
  //     match?.pathname as string,
  //     ""
  //   );
  //   return path;
  // }

  const { searchParams, network } = options ?? {};

  let result = buildPath(APP_URL.Base, url);

  if (searchParams) {
    const sp = createSearchParams(searchParams).toString();
    result = `${result}?${sp}`;
  }

  const pattern = matchPath(
    { path: APP_URL.Base, end: false },
    window.location.pathname
  );

  if (network) {
    return result.replace(":network", network);
  } else if (pattern?.params.network) {
    const _network = getNetworkFromUrl(pattern?.params.network);
    return result.replace(":network", _network);
  }

  return result.replace(":network", getDefaultNetwork());
};

export const PERMISSIONS = {
  SYSTEM_USER: {
    VIEW: "SystemUser.View",
    ADD: "SystemUser.Add",
    EDIT: "SystemUser.Edit",
    DELETE: "SystemUser.Delete",
  },
  FACTORY: {
    VIEW: "Factory.View",
    ADD: "Factory.Add",
    EDIT: "Factory.Edit",
    DELETE: "Factory.Delete",
  },
};

export enum EtudeStep {
  Start = 1,
  InputForm,
  Solutions,
  SolutionDetails,
  Accessoires,
  Documents,
}

export enum ObsolescenceType {
  ECS,
  PAC,
  Accessoires,
  CHAUFFAGE,
}
